import { ReadOnlyWarningType } from '../../../constants/read-only-warning-type-enum';

export const READ_ONLY_WARNING_MODAL_TITLE = 'Read Only Access';
export const READ_ONLY_WARNING_MODAL_CANCEL_TITLE = 'Close';

export const READ_ONLY_WARNING_MESSAGES: Record<ReadOnlyWarningType, string> = {
    [ReadOnlyWarningType.Application]:
        'This application has been handed over to EWA and is available only for viewing. Please contact your EWA Advisor if you require any changes.',
    [ReadOnlyWarningType.FrnRequest]:
        'This FRN request has been handed over to EWA and is available only for viewing. Please contact your EWA Advisor if you require any changes.',
    [ReadOnlyWarningType.Staff]:
        'This application has been submitted to the FCC or PSCA and is available only for viewing.',
};
